import gql from 'graphql-tag';

const MUTATION_RESTORE_USER = gql`
  mutation restoreUser($userId: ID!) {
    restoreUser(userId: $userId) {
      isSuccess
      message
    }
  }
`;

export default MUTATION_RESTORE_USER;
